import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/machine-learning-company/ml-sub-banner.webp";

function Expertmachine() {
  return (
    <section
      className="expert_machine"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-md-6">
            <h2 style={{ color: "#fff" }}>
              Transform Your Business with Expert ML Advice
            </h2>
            <p style={{ color: "#fff" }}>
              Share your ML needs with us, and we'll get back to you with a free
              consulting call. Our experts are ready to help you leverage
              advanced ML technologies to drive your business forward. Let's
              start your journey to innovation today.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Book Your Consultation
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Expertmachine;
